import { theme } from "antd";
import React, { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";

function PageThumbnailPanel({ pdfUrl, numPages, currentPage, setCurrentPage, annotations }) {
  const [loadedPages, setLoadedPages] = useState([]);
    const {
    token: {
      colorBorder,
      colorBgContainer,
      borderRadiusLG,
      colorBgLayout,
      colorBgBase,
      colorPrimary,
      colorPrimaryBg,
      colorText,
      colorError,
    },
  } = theme.useToken();

  useEffect(() => {
    setLoadedPages(Array.from({ length: numPages }, (_, i) => i + 1));
  }, [numPages]);

  return (
      <Document file={pdfUrl} loading={null}>
        {loadedPages.map(pageNum => {
          const isBookmarked = annotations.some(a => a.type === "bookmark" && a.page === pageNum);
          return (
            <div
              key={pageNum}
              onClick={() => setCurrentPage(pageNum)}
              style={{
                margin: "6px auto",
                border: pageNum === currentPage ? `2px solid ${colorPrimary}` : `1px solid ${colorBorder}`,
                borderRadius: 4,
                minWidth: 80,
                background: pageNum === currentPage ? colorPrimary : colorBgBase,
                cursor: "pointer",
              }}
            >
              <Page
                pageNumber={pageNum}
                width={76}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                loading={null}
              />
              <div style={{
                textAlign: "center",
                fontSize: 12,
                padding: 2,
                color: pageNum === currentPage ? colorPrimaryBg : colorText
              }}>
                {pageNum} {isBookmarked && <span style={{ color: colorError }}>🔖</span>}
              </div>
            </div>
          );
        })}
      </Document>
  );
}

export default PageThumbnailPanel;
